module.exports = __webpack_public_path__ + "public/close.ccc14770c9e6dabaa10a91d09019a405.html";